export const GET_drawer = ({ drawer }) => drawer
